module.exports = __webpack_public_path__ + "static/media/ProfileIcon1.a75762a5.svg";